import { Navigate, Outlet } from "react-router-dom";
import Dashboard from "../layout";

const PrivateRouter = () => {
    const isLoggedIn = true; //localStorage.getItem("ACCESS_TOKEN");
    return (
        <>
            {isLoggedIn ? (
                <Dashboard>
                    <Outlet />
                </Dashboard>
            ) : (
                <Navigate to="/" />
            )}
        </>
    );
}

export default PrivateRouter;